module.exports = __webpack_public_path__ + "img/arrow_plate_next.36c272fc.svg";